<template>
  <div class="product-details">
    <div class="product-details-box" v-if="product">
      <img :src="product.imageUrl" class="product-details-box-image" />

      <div class="product-details-box-info">
        <p class="title-text">
          {{ product.name }}
        </p>

        <p class="body-text">
          {{ product.description }}
        </p>

        <div class="border-space-breaker"></div>

        <div class="product-details-box-info-quantity">
          <QuantityComponent :placeHolder="__('item_quantity')" v-model="quantity" />
          <p class="body-text-bold">
            {{ store.formatPrice(product.price) }}
          </p>
        </div>

        <button class="button" @click="buyItem">
          <img src="@/assets/icons/starIcon.svg" />
          {{ __('product_buy') }}
        </button>
      </div>
    </div>
    <NotFoundComponent v-if="notFound" />
  </div>
</template>

<script lang="ts" setup>
import QuantityComponent from '@/components/form-components/QuantityComponent.vue';
import NotFoundComponent from '@/components/NotFoundComponent.vue';
import { generalStore } from '@/store';
import { Product } from '@/types';
import axios from 'axios';
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import __ from '@/translate';

const route = useRoute();
const router = useRouter();
const product = ref<Product | null>(null);
const store = generalStore();
const quantity = ref(1);
const notFound = ref(false);

onMounted(() => {
  fetchProductDetails();
});

function fetchProductDetails() {
  axios
    .get(`/api/products/${route.params.id}`)
    .then((response) => {
      product.value = response.data;
    })
    .catch(() => {
      notFound.value = true;
    });
}

function buyItem() {
  if (product.value) {
    router.push({
      name: 'CheckoutPage',
      params: {
        id: product.value.id,
        quantity: quantity.value,
      },
    });
  }
}
</script>
